/* CEN Fit My Car - shared behaviour for every vehicle fit finder.
   1) Products not stocked on cen.uk ("Ask us" rows) are listed below the available products.
   2) "Ask us" opens the contact page with the product, brand and vehicle carried across;
      the contact page selects a "Product Question: ..." subject and pre-fills the message. */
(function () {
  var BRANDS = { 'data-cen-fit': 'Focal', 'data-cen-match-fit': 'MATCH', 'data-cen-helix-fit': 'HELIX', 'data-cen-atf-fit': 'Audiotec Fischer', 'data-cen-aud-fit': 'Audison', 'data-cen-pio-fit': 'Pioneer', 'data-cen-option-fit': 'Option Audio', 'data-cen-opt-fit': 'Option Audio', 'data-cen-rs-fit': 'RetroSound', 'data-cen-ict-fit': '', 'data-cen-vs': '' };
  function txt(el) { return (el ? el.textContent : '').replace(/\s+/g, ' ').trim(); }

  /* ---------- finder pages ---------- */
  function isAvailable(child) {
    if (child.classList.contains('cen-fit__product')) return true;
    if (child.classList.contains('cen-fit__part')) return false;
    var first = child.querySelector('.cen-fit__product, .cen-fit__part');
    return !!(first && first.classList.contains('cen-fit__product'));
  }
  function reorder(list) {
    var kids = [].slice.call(list.children).filter(function (c) { return c.matches('.cen-fit__product, .cen-fit__part, .cen-fit__item, .cen-fit__prow'); });
    if (kids.length < 2) return;
    var avail = kids.filter(isAvailable), rest = kids.filter(function (c) { return !isAvailable(c); });
    if (!rest.length || !avail.length) return;
    var lastAvail = kids.lastIndexOf(avail[avail.length - 1]), firstRest = kids.indexOf(rest[0]);
    if (lastAvail < firstRest) return; /* already in order */
    avail.concat(rest).forEach(function (c) { list.appendChild(c); });
  }
  function brandOf(root) {
    for (var k in BRANDS) if (root.hasAttribute(k)) return BRANDS[k];
    var h = root.closest('.cen-vs__brand');
    return h ? txt(h.querySelector('.cen-fit__vtitle')).split(/\s{2,}/)[0] : '';
  }
  function vehicleOf(results) {
    var t = txt(results.querySelector('.cen-fit__count'));
    var m = t.match(/(?:for your|fit your|of the|for the)\s+(.+?)(?:\s+\u2013\s+choose yours)?$/i);
    return m ? m[1] : '';
  }
  function linkAsks(root, results) {
    var contact = root.getAttribute('data-contact-url') || '/pages/contact';
    var car = vehicleOf(results);
    [].forEach.call(results.querySelectorAll('.cen-fit__part a'), function (a) {
      if (!/ask us/i.test(a.textContent) || a.getAttribute('data-cen-ask')) return;
      var part = a.closest('.cen-fit__part'), strong = part.querySelector('span strong, strong'), label = (strong ? txt(strong) : '') || txt(part.querySelector('span')) || txt(part).replace(/\b(Search|Ask us)\b/g, '').trim();
      var art = txt(part.querySelector('.cen-fit__art')).replace(/^Item\s+/i, '');
      if (art && label.indexOf(art) < 0) label = label.replace(/\s*Item\s+\S+$/i, '') + ' (' + art + ')';
      var brandBlock = a.closest('.cen-vs__brand');
      var brand = brandBlock ? txt(brandBlock.querySelector('.cen-fit__vtitle')).replace(/\s+(listed by|for your).*$/i, '') : brandOf(root);
      var q = '?product=' + encodeURIComponent(label.slice(0, 150)) + (brand ? '&brand=' + encodeURIComponent(brand) : '') + (car ? '&car=' + encodeURIComponent(car) : '');
      a.setAttribute('href', contact.split('?')[0] + q);
      a.setAttribute('data-cen-ask', '1');
    });
  }
  function tidy(root) {
    var results = root.querySelector('[data-fit-results]'); if (!results) return;
    [].forEach.call(results.querySelectorAll('.cen-fit__items, .cen-fit__parts'), reorder);
    linkAsks(root, results);
  }
  function watch(root) {
    var results = root.querySelector('[data-fit-results]'); if (!results || results.__cenWatch) return;
    results.__cenWatch = true;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { tidy(root); }, 60); }).observe(results, { childList: true, subtree: true });
    tidy(root);
  }
  function scan() {
    [].forEach.call(document.querySelectorAll('[data-fit-results]'), function (r) {
      var root = r.closest('section, [data-cen-fit], [data-cen-vs]') || r.parentNode;
      while (root && root.parentElement && ![].some.call(root.attributes, function (x) { return /^data-cen-/.test(x.name); })) root = root.parentElement;
      watch(root || r.parentNode);
    });
  }

  /* ---------- contact page ---------- */
  function contactPrefill() {
    var q; try { q = new URL(location.href).searchParams; } catch (e) { return; }
    var product = q.get('product'); if (!product) return;
    var brand = q.get('brand') || '', car = q.get('car') || '';
    var name = (brand && product.toLowerCase().indexOf(brand.toLowerCase()) !== 0 ? brand + ' ' : '') + product;
    var form = [].filter.call(document.querySelectorAll('form'), function (f) { return f.querySelector('[name^="contact["]'); })[0]; if (!form) return;
    var subj = form.querySelector('select[name="contact[Subject]"], select[name="contact[subject]"]');
    var label = ('Product Question: ' + name).slice(0, 180);
    if (subj) {
      var opt = [].filter.call(subj.options, function (o) { return o.value === label; })[0];
      if (!opt) { opt = document.createElement('option'); opt.value = label; opt.textContent = label; subj.insertBefore(opt, subj.options[1] || null); }
      subj.value = label; subj.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      var s2 = form.querySelector('input[name="contact[subject]"], input[name="contact[Subject]"]'); if (s2 && !s2.value) s2.value = label;
    }
    var body = form.querySelector('textarea[name="contact[body]"]');
    if (body && !body.value) body.value = 'Hi, I\u2019d like to ask about: ' + name + (car ? '\nVehicle: ' + car : '') + '\n\n';
  }

  /* ---------- Safari: stop the grey finder background flickering while images load on scroll ---------- */
  function safariFix() {
    if (document.getElementById('cen-fit-safari')) return;
    var st = document.createElement('style'); st.id = 'cen-fit-safari';
    st.textContent = '.cen-fit{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);-webkit-backface-visibility:hidden;backface-visibility:hidden}' +
      '.cen-fit .cen-fit__product,.cen-fit img{-webkit-backface-visibility:hidden;backface-visibility:hidden}';
    document.head.appendChild(st);
  }

  function init() { safariFix(); scan(); contactPrefill(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); }); else setTimeout(init, 0);
  window.addEventListener('load', scan);
})();
